import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import {
    EventsManager,
    GameEvents,
    ReelsEvents,
    WinEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { fadeAndStopSound } from "../../../abstracts/utils/SoundUtils";
import { DDD } from "../../DDD";
import { DDDSoundNames } from "../../assetsLoader/DDDAssetsNames";
import DDDReel from "../../modules/Reels/DDDReel";
import { DDDReelsView } from "../../modules/Reels/DDDReelsView";
import { DDDXNudgeSymbol } from "../../modules/Reels/symbols/DDDXNudgeSymbol";
import { DDDWinView } from "../../modules/Winnings/DDDWinView";

export class DDDFreespinIdlePresentation extends AbstractFlowPresentation {
    protected winView: DDDWinView;
    protected reelsView: DDDReelsView;
    protected DDDReels: DDDReel[];

    constructor(id: string = `DDDFreespinIdlePresentation`) {
        super(id);
    }

    protected handleEvents() {
        super.handleEvents();

        EventsManager.on(WinEvents.GET_WINNINGS_VIEW, (winningsView: DDDWinView) => {
            this.winView = winningsView;
        });

        EventsManager.on(ReelsEvents.GET_REELS, (reels: DDDReel[]) => {
            this.DDDReels = reels;
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: DDDReelsView) => {
            this.reelsView = reelsView;
        });
    }

    protected get gameMode(): AbstractGameMode {
        return AbstractGameMode.FREESPIN;
    }

    protected onIntroScreenComplete() {
        this.keypad.setZeroBetSpinCounter(DDD.model.data.freespinsLeft);
        this.showFastSpinButton();

        if (!DDD.model.data.isRestoreState) {
            const isWinBeloWStake = DDD.model.isWinBelowStake(true);

            this.keypad.setWin(
                this.model.data.accumulatedRoundWin,
                !isWinBeloWStake,
                isWinBeloWStake
            );
        }

        this.finishPresentation();
    }

    protected finishController() {
        SlotGame.apiPlugin.betHandler.zeroBet();
        super.finishController();
    }

    public override start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        EventsManager.trigger(GameEvents.DISABLE_IDLE_ANIMATIONS);
    }

    protected override onRestoreStart() {
        super.onRestoreStart();
        this.hideFastSpinButton();

        const isWinBeloWStake = DDD.model.isWinBelowStake(true);

        this.keypad.setWin(this.model.initData.accumulatedRoundWin, true, isWinBeloWStake);

        this.initializeTimeline(() => {
            this.winView.showFreespinRestoreScreen(
                this.model.initData.freespinsLeft,
                this.onIntroScreenComplete.bind(this),
                this.model.initData.nextMode === AbstractGameMode.SUPER_FREESPIN
            );
        });

        this.restoreNudges();
    }

    protected onDefaultStart() {
        super.onDefaultStart();

        if (
            this.model.data.mode !== AbstractGameMode.FREESPIN &&
            this.model.data.nextMode === AbstractGameMode.FREESPIN
        ) {
            this.keypad.setWin(-1, true, true, true);
            this.hideFastSpinButton();

            fadeAndStopSound({
                name: DDDSoundNames.MAIN_MUSIC,
                duration: 0.5,
                from: 1,
                to: 0,
            });

            this.winView.showFreespinIntroScreen(
                this.onIntroScreenComplete.bind(this),
                this.model.data.freespinsLeft
            );
        } else {
            this.flowPresentationTimeline.resume();
        }
    }

    protected restoreNudges() {
        this.DDDReels.forEach((reel, reelIndex: number) => {
            if (DDD.model.initData.stickyXNudge[reelIndex]) {
                reel.isLocked = true;
                this.flowPresentationTimeline.add(
                    (reel.xNudgeSymbol as DDDXNudgeSymbol)!.restore(DDD.model.initData, reelIndex)
                );
            }
        });
        this.flowPresentationTimeline.progress(1);
    }
}
